import * as React from 'react';

const Chart24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.25 2a.75.75 0 0 1 .75.75V20.5h3V9a.75.75 0 0 1 1.5 0v11.5h1.75a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H4.5V10A.75.75 0 0 1 6 10v10.5h3V15a.75.75 0 0 1 1.5 0v5.5h3V2.75a.75.75 0 0 1 .75-.75"
  }
));
Chart24.Size = 24;
Chart24.Title = "Chart";

export { Chart24 as default };
